import { resolveFeaturePermissions } from '@vacationtracker/shared/functions/resolve-feature-permissions'
import { useAppSelector } from '../store/hooks'
import { selectAuthCompanySlice } from '../store/auth-company-slice'

export const useIsVeeEnabled = (): boolean => {
  const { authCompany } = useAppSelector(selectAuthCompanySlice)
  return Boolean(resolveFeaturePermissions(authCompany ?? {}).featureVisibility.veeEnabled)
}
